export type ApiResponse<T> = {
  success: true
  data: T
}

export type ProfileListItem = {
  id: string
  name: string
  skills: string[]
  interview_depth: number
}

export type Profile = {
  id: string
  profile: string
}

export const JOB_STATUSES = ['Draft', 'Open', 'On Hold', 'Interviewing', 'Filled', 'Closed'] as const
export type JobStatus = typeof JOB_STATUSES[number]

export const JOB_TYPES = ['Imported', 'Listed', 'Exclusive'] as const
export type JobType = typeof JOB_TYPES[number]

export type JobListItem = {
  id: string
  title: string
  employer: string
  status: JobStatus
  type: JobType
  required_topics: string[]
}

export type Job = {
  id: string
  job: string
}

export type MatchResult = {
  id: string
  name: string
  score: number
  reasons: string[]
}

export type TelegramStatus = {
  connected: boolean
  deepLink?: string
  chatId?: number
}
